import MuiButton from "components/Button";
import { Box, Divider, Grid, Typography } from "@material-ui/core";
import { AddSquare } from "iconsax-react";

const IOS = ({ handleClose, setSeenPWA }) => (
	<Grid container>
		<Grid xs={12} item style={{ margin: '26px 0' }}>
			<Typography
				component={'span'}
				style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontWeight: 500, color: '#25233D' }}
			>
				1. در نوار پایین مرورگر Safari، دکمه{' '}
				<Box
					component={'span'}
					style={{
						padding: '8px',
						borderRadius: '8px',
						border: '1px solid #D4D3E0',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						width: '34px',
						height: '34px',
						margin: '0 8px',
					}}
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M12.0051 15.0208C12.4411 15.0208 12.8062 14.654 12.8062 14.226V3.7603L12.7454 2.23172L13.4248 2.95525L14.9662 4.60611C15.1082 4.76916 15.3211 4.85069 15.5138 4.85069C15.9296 4.85069 16.2541 4.54497 16.2541 4.12716C16.2541 3.91316 16.1628 3.75011 16.0107 3.59725L12.5831 0.275144C12.3803 0.0713336 12.2079 0 12.0051 0C11.7921 0 11.6197 0.0713336 11.4169 0.275144L7.9893 3.59725C7.83718 3.75011 7.74592 3.91316 7.74592 4.12716C7.74592 4.54497 8.05014 4.85069 8.47606 4.85069C8.66873 4.85069 8.89183 4.76916 9.0338 4.60611L10.5752 2.95525L11.2546 2.23172L11.1938 3.7603V14.226C11.1938 14.654 11.569 15.0208 12.0051 15.0208ZM6.18423 23H17.8158C19.9352 23 21 21.9402 21 19.8409V9.6708C21 7.57156 19.9352 6.51174 17.8158 6.51174H14.9865V8.15241H17.7854C18.7893 8.15241 19.3673 8.7027 19.3673 9.76252V19.7492C19.3673 20.809 18.7893 21.3593 17.7854 21.3593H6.20451C5.19042 21.3593 4.63268 20.809 4.63268 19.7492V9.76252C4.63268 8.7027 5.19042 8.15241 6.20451 8.15241H9.01352V6.51174H6.18423C4.06479 6.51174 3 7.57156 3 9.6708V19.8409C3 21.9402 4.06479 23 6.18423 23Z"
							fill="#2E7CF6"
						/>
					</svg>
				</Box>
				را بزنید.
			</Typography>
		</Grid>
		<Grid xs={12} item>
			<Divider style={{ background: '#E9E9F0', height: 1, width: '100%' }} />
		</Grid>

		<Grid xs={12} item style={{ margin: '26px 0' }}>
			<Typography
				component={'span'}
				style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontWeight: 500, color: '#25233D' }}
			>
				2. در منوی بازشده در پایین، گزینه زیر را بزنید:
			</Typography>

			<Box width={'90%'} margin={'0 auto'}>
				<Box
					style={{
						marginTop: '10px',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						border: '1px solid #E9E9F0',
						boxShadow: '0px 8px 24px -8px #ECEDF3',
						padding: '10px 16px',
						borderRadius: '8px',
					}}
				>
					<Box>
						<AddSquare style={{ marginBottom: '-2px' }} />
					</Box>
					<Box>Add to Home Screen</Box>
				</Box>
			</Box>
		</Grid>
		<Grid xs={12} item>
			<Divider style={{ background: '#E9E9F0', height: 1, width: '100%' }} />
		</Grid>

		<Grid xs={12} item style={{ margin: '26px 0' }}>
			<Typography
				component={'span'}
				style={{ display: 'flex', alignItems: 'baseline', fontSize: 15, fontWeight: 500, color: '#25233D' }}
			>
				3. سپس، در قسمت بالا روی
				<Box
					component={'span'}
					style={{
						color: '#2E7CF6',
						fontSize: '17px',
						fontWeight: 400,
						margin: '0 4px -10px 4px',
					}}
				>
					Add
				</Box>
				بزنید.
			</Typography>
		</Grid>

		<Grid xs={12} item style={{ marginBottom: '32px' }}>
			<MuiButton
				onClick={() => {
					setSeenPWA(true);
					handleClose();
				}}
			>
				متوجه شدم
			</MuiButton>
		</Grid>
	</Grid>
);

export default IOS;
